import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'tangram-syllabus-upload',
  templateUrl: './syllabus-upload.component.html',
  styleUrls: ['./syllabus-upload.component.scss']
})
export class SyllabusUploadComponent {
  fileName: string = '';
  @Output() fileSelected = new EventEmitter<{ fileName: string; file: File | null }>();

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input && input.files && input.files.length ? input.files[0] : null;
    this.fileName = file ? file.name : '';
    this.fileSelected.emit({ fileName: this.fileName, file: file });
  }
}
